import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class FloweringStage extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Flowering Stage
        </h2>
        <p>
        <span className="highlight"> Timeline: Varies by strain. Most plants need 6 to 8 weeks, while others need as much as 10 - 12 weeks.</span>
        </p>
        <h3>Light Schedule</h3>
        <p>
        The flowering stage is the final stage of plant growth when a marijuana plants begins to produce bud. Flowering is a result of the light cycle the plant receives. In order to activate flowering, you will need to switch your lighting schedule to a strict schedule of 12 hours of light and 12 hours of total darkness. Total darkness means total darkness, any light leaks can cause damage and confuse the plant which will impact your final yield. During flowering your plants will experience rapid vertical growth so make sure you have prepared adequate space.
        </p>
        <p>
        Red lights are ideal for the flowering stage, although not a necessity if your light does not allow switching colors. At this point you’ll also want to begin adding nutrients catered to the flowering stage as well as nutrient that boost blooming. 
        </p>
        <GuideButton slugTo="flushing" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_flowering_stage.js